import { render, staticRenderFns } from "./play-page.vue?vue&type=template&id=b11428fc&scoped=true&"
import script from "./play-page.vue?vue&type=script&lang=js&"
export * from "./play-page.vue?vue&type=script&lang=js&"
import style0 from "./play-page.vue?vue&type=style&index=0&id=b11428fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11428fc",
  null
  
)

export default component.exports